{
  "alert.informative": "Informatiivne",
  "alert.negative": "Negatiivne",
  "alert.notice": "Teatis",
  "alert.positive": "Positiivne",
  "attachmentlist.nextAttachments": "Kuva järgmised manused",
  "attachmentlist.previousAttachments": "Kuva eelmised manused",
  "chat.newMessage": "Uus sõnum",
  "chat.scrollToBottom": "Keri alla",
  "messagefeedback.thumbDown": "Halb vastus",
  "messagefeedback.thumbUp": "Hea vastus",
  "promptfield.aiDisclaimer": "Tehisintellekti loodud vastused võivad olla ebatäpsed. Kontrollige neid enne kasutamist.",
  "promptfield.aiUserGuidlines": "Tehisintellekti kasutusjuhised",
  "promptfield.attachments": "Manused",
  "promptfield.insertButton": "Lisa",
  "promptfield.label": "Viip",
  "promptfield.placeholder": "Kas te olete valmis alustama? Esitage küsimus, jagage ideed või lisage ülesanne.",
  "promptfield.placeholder.small": "Küsige mida tahes",
  "promptfield.stopButton": "Peata",
  "promptfield.submitButton": "Saada",
  "promptfield.uploading": "Üleslaadimine",
  "responsestatus.loading": "Laadimine",
  "responsestatus.processing": "Töötlemine...",
  "voicebutton.startListening": "Alusta salvestamist",
  "voicebutton.stopListening": "Lõpeta salvestamine"
}
